export const isSpaceValidateTextField = (value) => {
  if (value && !value?.trim()) return false;
  return true;
};

export const isSpaceValidateEditor = (editorState) => {
  const plainText = editorState?.getCurrentContent()?.getPlainText();
  if (!plainText || !plainText.trim()) {
    return false;
  }
  return true;
};
